import React from 'react';
import { Link } from 'react-router-dom';
import { Crown, MonitorPlay, Layers, Route, ArrowLeft, ArrowRight } from 'lucide-react';
import { useLang, tx } from '../../i18n/LanguageContext';

const JOIN_IMG = 'https://static.prod-images.emergentagent.com/jobs/2f8d28b7-4ebe-4317-8ba5-2c9c19007ec7/images/b4de568af075833c97df9df3d689e0ea0fd89909afe34b6d413d405d741c80a5.jpeg';

const JoinBanner = () => {
  const { lang, isRTL } = useLang();
  const L = (ar, en) => tx(lang, ar, en);
  const Arrow = isRTL ? ArrowLeft : ArrowRight;
  const perks = [
    { Icon: MonitorPlay, text: L('محاكاة تفاعلية حصرية', 'Exclusive simulations') },
    { Icon: Layers, text: L('كورسات ودروس عملية كاملة', 'Complete practical courses') },
    { Icon: Route, text: L('مسارات تعلّم موجّهة', 'Guided learning paths') },
  ];
  return (
    <section data-testid="home-join-banner" className="py-6 sm:py-8">
      <div className="site-container">
        <div className="relative overflow-hidden rounded-[28px] bg-gradient-to-l from-blue-800 via-blue-700 to-blue-900 shadow-xl shadow-blue-900/20 grid grid-cols-1 lg:grid-cols-[1.4fr_1fr] items-center">
          <div className="absolute inset-0 hero-grid-dark opacity-25 pointer-events-none" />
          <div className="relative min-w-0 p-6 sm:p-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black text-white mb-2">{L('انضم الآن إلى AutoMeet Network', 'Join AutoMeet Network now')}</h2>
            <p className="text-xl sm:text-2xl font-black text-amber-300 mb-4">{L('وافتح كامل إمكانات التعلّم العملي', 'and unlock the full hands-on experience')}</p>
            <p className="text-blue-100 text-sm sm:text-base leading-relaxed mb-6 max-w-2xl">{L('باشتراكك ستحصل على إمكانية الوصول إلى المحاكاة التفاعلية الحصرية، ودروس عملية تطبيقية، ومسارات تعلّم موجّهة من الأساس إلى الاحتراف.', 'Your subscription unlocks the exclusive interactive simulations, practical lessons and guided learning paths from basics to pro.')}</p>
            <div className="flex flex-col sm:flex-row sm:items-center gap-5">
              <Link to="/subscription" data-testid="home-join-cta" className="btn-subscribe h-auto min-h-12 py-3 px-6 whitespace-normal text-center"><Crown className="w-5 h-5" />{L('اشترك الآن واستفد من جميع المزايا', 'Subscribe and get every benefit')}<Arrow className="w-4 h-4" /></Link>
              <ul className="flex flex-wrap gap-x-5 gap-y-2">
                {perks.map(p => <li key={p.text} className="flex items-center gap-2 text-white text-xs sm:text-sm font-semibold"><p.Icon className="w-5 h-5 text-blue-200" />{p.text}</li>)}
              </ul>
            </div>
          </div>
          <img src={JOIN_IMG} alt="" className="relative w-full h-full max-h-72 lg:max-h-none object-cover" />
        </div>
      </div>
    </section>
  );
};

export default JoinBanner;
